import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $accountForIntegrationsStore, $profileFeatureStore, $profileStore } from '@lib/store';
import { useListState, useRouteHook } from '@shared/hooks';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import { UserType, type IntegrationType } from '@shared/api';
import { Accounts, IntegrationTitle } from './widgets';
import { PageContainer } from '@widgets';

export const IntegrationPage = () => {
  const params = useParams<{ id: IntegrationType }>();
  const { navigate } = useRouteHook();

  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const profileStore = useUnit($profileStore.store);

  const [currency, setCurrency] = useState<string>();
  const integrationState = useListState({ list: 'integration' });

  const { t } = useTranslation('integration');

  useEffect(() => {
    return () => $accountForIntegrationsStore.events.clear();
  }, []);

  useEffect(() => {
    if (!profileStore.data?.userType) return;
    if (
      profileStore.data?.userType !== UserType.Admin ||
      !profileFeatureStore.data?.accountFlows?.some((accountFlow) => accountFlow.integrations) ||
      PaletteUtils.isPersonalPalette
    ) {
      navigate(RoutePaths.dashboard.onNavigate());
      return;
    }

    $accountForIntegrationsStore.events.getAccountsForIntegrations({
      Count: integrationState.count,
      FromIndex: integrationState.fromIndex,
      ReturnTotalCount: true,
      Currency: currency,
    });
  }, [profileStore.data?.userType, currency, integrationState]);

  return (
    <PageContainer title={t('title')} back backText={t('backText')}>
      <IntegrationTitle name={params.id!} currency={currency} onChangeCurrency={setCurrency} />
      <Accounts
        integration={params.id!}
        currency={currency}
        currentPage={integrationState.page}
        countItemPage={integrationState.count}
        onChangePage={integrationState.onChangePage}
        onChangeCountItemPage={integrationState.onChangeCount}
      />
    </PageContainer>
  );
};
